<script setup lang="ts">
import t from "~/utils/translate";
import Button from "../ui/Button.vue";
import { DateTime as Luxon } from "luxon";

const cookie = useCookie("betway-cookie-policy", {
	expires: Luxon.now().plus({ days: 7 }).toJSDate(),
});

const handleClick = () => {
	cookie.value = "true";
};
</script>

<template>
	<div
		v-if="!cookie"
		class="fixed bottom-0 text-xs lg:text-base lg:bottom-0 left-0 bg-dark-700 text-light-50 p-2 w-full z-50 flex justify-between gap-3 md:gap-1 flex-col lg:flex-row text-center lg:text-left"
	>
		<span>
			{{ t("cookie-acceptance-notice") }} <NuxtLink to="/privacy-policy" class="inline-block">{{ t("cookie-policy") }}</NuxtLink>
		</span>

		<Button @click="handleClick()" class="uppercase" :label="t('got-it')" size="small" />
	</div>
</template>
